import {
  POWERS_WEIGHT_DEFAULT,
  POWERS_WEIGHT_MIN,
  densifyElementWeights,
  normalizePowersWeight,
} from "@/components/match/match-design-rules";
import type { CreativityElement, TeamProfileCoreFragment } from "@/graphql/generated/operations";

// Draft-Modell eines Power-Profils, geteilt von Detailkarte (bearbeiten) und
// Anlegeformular (neu oder als Kopie). Reine Umrechnung Server <-> Draft, damit
// "Gewichte einer Scorecard uebernehmen" dieselbe Lesart hat wie die Karte, die
// diese Gewichte anzeigt.

export interface TeamProfileDraft {
  german: string;
  english: string;
  elementWeights: Record<string, number>;
}

// Server values a draft is edited against. Densify with 0: a preset's omitted
// key means "doesn't matter", same reading as the Match picker seam.
export function profileToDraft(profile: TeamProfileCoreFragment): TeamProfileDraft {
  const weights: Record<string, number> = {};
  for (const { element, weight } of profile.weights ?? []) {
    if (element) weights[element] = normalizePowersWeight(weight);
  }
  return {
    german: profile.localizedName?.german ?? "",
    english: profile.localizedName?.english ?? "",
    elementWeights: densifyElementWeights(weights, POWERS_WEIGHT_MIN),
  };
}

// A profile created without a source starts at the neutral baseline across
// all 30 powers; the weights are then tuned in the card's editor.
export function neutralElementWeights(): Record<string, number> {
  return densifyElementWeights({}, POWERS_WEIGHT_DEFAULT);
}

export function weightsInput(elementWeights: Readonly<Record<string, number>>) {
  return Object.entries(elementWeights).map(([element, weight]) => ({
    // Codegen emits CreativityElement in two files, so element keys are carried
    // as plain strings and narrowed here, see the note in lib/elements.ts.
    element: element as CreativityElement,
    weight,
  }));
}
